var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Heart = function Heart(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.411 6.011a4 4 0 0 0-3.214 6.844l.007.006L12 19.593l6.796-6.732a1 1 0 0 1 .064-.058 4 4 0 1 0-6.06-5.196 1 1 0 0 1-1.603-.004A4 4 0 0 0 8.412 6.01Zm11.724 8.34-7.431 7.36a1 1 0 0 1-1.408 0L3.8 14.285a6 6 0 0 1 8.205-8.754 5.998 5.998 0 0 1 7.947-.034 6 6 0 0 1 .25 8.793.992.992 0 0 1-.066.06Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Heart;